import { registerPlugin } from '@capacitor/core';
const Ocr = registerPlugin('Ocr');
export * from './definitions';
export { Ocr };
//# sourceMappingURL=index.js.map